import { Injectable, Inject } from '@angular/core';
import { Observable, of, pipe, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { COMMON_API_URL } from '@common/app/app.config';
import { UsAddress } from '../model/address';

@Injectable()
export class AddressesLookupService {

    constructor(private http: HttpClient, @Inject(COMMON_API_URL) protected baseCommonUrl: string) {
    }

    getAddressByEsiId(esiId: number): Observable<UsAddressServiceResponce> {
        return this.http.get<UsAddressServiceResponce>(this.baseCommonUrl +
            '/GetUsAddressByEsiId?esiId=' + esiId);
    }

    getAddressByAddress(streetName: string, streetNumber: string, zip: string): Observable<UsAddressServiceResponce> {
        streetNumber = streetNumber ? streetNumber : '';
        return this.http.get<UsAddressServiceResponce>(this.baseCommonUrl +
            '/GetUsAddressByZipStreetNameAndStreetNumber?streetNr=' + streetNumber +
            '&streetName=' + streetName + '&zip=' + zip);
    }
}

// Operator to filter out inactive addresses, if resulting list is empty, throw an error, as would the AddressService.
export const rejectInactive = () => {
    return pipe(
        map((addressesResponse: UsAddressServiceResponce) => {
            addressesResponse.rows = addressesResponse.rows.filter(a => a.meter_status !== 'Inactive');
            return addressesResponse;
        }),
        switchMap((addressesResponse) =>
            addressesResponse.rows.length > 0 ? of(addressesResponse) : throwError('No Active addresses found'))
    );
}

export const removeFirstZeros = () => {
    return pipe(
        map((addressesResponse: UsAddressServiceResponce) => {
            addressesResponse.rows = addressesResponse.rows.map(a => {
                a.address = a.address.replace(/^0+/, '');
                return a;
            });
            return addressesResponse;
        })
    );
}

export class UsAddressServiceResponce {
    message?: any;
    success: boolean;
    rows: UsAddress[];
}
